import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';
import {GetFeaturesUserManualLink} from 'domain/usecases/private/external-links/user-manual/get-features-user-manual';
import {RemoteGetFeaturesUserManualLink} from 'data/usecases/private/external-links/user-manual/remote-get-features-user-manual';

export const makeGetFeaturesUserManualLink = (): GetFeaturesUserManualLink =>
	new RemoteGetFeaturesUserManualLink(
		makeBFFApiUrl(ExternalLinkPoint.featuresUserManual),
		makeAuthorizeHttpClientDecorator(),
	);
